import { Button, Tooltip } from '@mui/material';
import type { ButtonProps, SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';

interface ActionTextBtnProps extends Omit<ButtonProps, 'children'> {
  label: ReactNode;
  tooltipTitle?: ReactNode;
}

const ActionTextBtn = ({ label, tooltipTitle, sx, variant = 'outlined', size = 'small', ...buttonProps }: ActionTextBtnProps) => {
  const actionSx = Array.isArray(sx) ? [ActionTextBtn_Styles(), ...sx] : [ActionTextBtn_Styles(), sx];

  const button = (
    <Button
      variant={variant}
      size={size}
      sx={actionSx}
      {...buttonProps}
    >
      {label}
    </Button>
  );

  if (!tooltipTitle) return button;

  return <Tooltip title={tooltipTitle}>{button}</Tooltip>;
};

export default ActionTextBtn;

export const ActionTextBtn_Styles = (): SxProps<Theme> => ({
  minWidth: 'max-content',
  height: 32,
  px: 1.5,
  borderRadius: '8px',
  borderColor: 'divider',
  bgcolor: 'background.paper',
  color: 'text.primary',
  fontWeight: 600,
  '& .MuiButton-startIcon': {
    mr: 0.75,
    color: 'inherit',
  },
  '& svg': {
    fontSize: 18,
  },
  '&:hover': {
    borderColor: 'primary.main',
    bgcolor: 'background.BrokenWhite',
    color: 'primary.main',
  },
  '&.Mui-disabled': {
    borderColor: 'divider',
    bgcolor: 'action.disabledBackground',
    color: 'text.disabled',
  },
});
